module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/111-afghanistan-56beaafbddd47db77464e337b21c5e1f.svg";